import { reducerFromMap } from "../libs/helpers/reducers";
import {
  getPaginatedProps,
  getDetailAndSchemaProps,
  getDetailProps,
} from "../libs/helpers/callApi";

import {
  CONTACT_ENTITY_LOADING,
  CONTACT_ENTITY_LOADED,
  CONTACT_ENTITY_LOAD_ERROR,
  CONTACT_LIST_LOADING,
  CONTACT_LIST_LOADED,
  CONTACT_LIST_LOAD_ERROR,
  CONTACT_DETAIL_LOADING,
  CONTACT_DETAIL_LOADED,
  CONTACT_DETAIL_LOAD_ERROR,
  CONTACT_COMPANY_LOADING,
  CONTACT_COMPANY_LOADED,
  CONTACT_COMPANY_LOAD_ERROR,
  CONTACT_BRAND_LOADING,
  CONTACT_BRAND_LOADED,
  CONTACT_BRAND_LOAD_ERROR,
  CONTACT_DETAIL_EDITING,
  CONTACT_DETAIL_EDITED,
  CONTACT_DETAIL_EDIT_ERROR,
} from "../actions/contact.actions";

const reducer = {
  /*
   * CONTACT_ENTITY
   */
  [CONTACT_ENTITY_LOADING]: (state) => ({
    ...state,
    entity: { loading: true },
  }),
  [CONTACT_ENTITY_LOADED]: (state, { data }) => ({
    ...state,
    entity: {
      loading: false,
      schema: data,
    },
  }),
  [CONTACT_ENTITY_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    entity: { loading: false },
    error: data,
  }),
  /*
   * CONTACT_LIST
   */
  [CONTACT_LIST_LOADING]: (state) => ({
    ...state,
    list: { ...state.list, loading: true },
  }),
  [CONTACT_LIST_LOADED]: (state, { data }) => ({
    ...state,
    list: { loading: false, ...getPaginatedProps(data) },
  }),
  [CONTACT_LIST_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    list: { ...state.list, loading: false },
    error: data,
  }),
  /*
   * CONTACT_DETAIL
   */
  [CONTACT_DETAIL_LOADING]: (state) => ({
    ...state,
    detail: {
      // ...state.detail,
      loading: true,
      error: null,
    },
  }),
  [CONTACT_DETAIL_LOADED]: (state, { data }) => ({
    ...state,
    detail: {
      loading: false,
      error: null,
      ...getDetailAndSchemaProps(data),
    },
  }),
  [CONTACT_DETAIL_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    detail: { loading: false },
    error: data,
  }),
  /*
   * CONTACT EDIT
   */
  [CONTACT_DETAIL_EDITING]: (state) => ({
    ...state,
    detail: { ...state.detail, loading: true },
  }),
  [CONTACT_DETAIL_EDITED]: (state, { data }) => ({
    ...state,
    detail: {
      ...state.detail,
      loading: false,
      ...getDetailProps(data),
    },
  }),
  [CONTACT_DETAIL_EDIT_ERROR]: (state, { data }) => ({
    ...state,
    detail: { loading: false },
    error: data,
  }),
  /*
   * CONTACT_COMPANY
   */
  [CONTACT_COMPANY_LOADING]: (state) => ({
    ...state,
    company: {
      // ...state.company,
      loading: true,
    },
  }),
  [CONTACT_COMPANY_LOADED]: (state, { data }) => ({
    ...state,
    company: {
      loading: false,
      ...getDetailAndSchemaProps(data),
    },
  }),
  [CONTACT_COMPANY_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    company: { loading: false },
    error: data,
  }),
  /*
   * CONTACT_BRAND
   */
  [CONTACT_BRAND_LOADING]: (state) => ({
    ...state,
    brands: {
      // ...state.brands,
      loading: true,
    },
  }),
  [CONTACT_BRAND_LOADED]: (state, { data }) => ({
    ...state,
    brands: {
      loading: false,
      ...getDetailAndSchemaProps(data),
    },
  }),
  [CONTACT_BRAND_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    brands: { loading: false },
    error: data,
  }),
};

export default reducerFromMap(reducer, { list: {} });
